import { render, staticRenderFns } from "./ImsImportCustomer.vue?vue&type=template&id=2fbc21e1&"
import script from "./ImsImportCustomer.vue?vue&type=script&lang=js&"
export * from "./ImsImportCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports